import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row as VdsRow } from '@vds/grids';

import { Body, Title as VdsTitle } from '../../../Typography';
import { isMobile } from '../../../Helpers';

const Row = styled(VdsRow)`
  margin-left: 0px;
  margin-right: 0px;
`;

const Spacing = styled.div`
  padding: ${({ padding }) => padding && padding.map((value) => `${value}px`).join(' ')};
`;

const CommonDiscount = ({ title, planName, charges }) => {
  const showMobileFontSize = isMobile();

  return (
    <div className="oneTimeChargesSection">
      {title && (
        <Spacing padding={[32, 0, 24, 0]} className="textAlignLeft">
          <VdsTitle size="small" primitive="h3">
            {title}
          </VdsTitle>
        </Spacing>
      )}
      <Row className="justify-space-between">
        <Spacing padding={[0, 0, 3, 0]} className="width60 textAlignLeft">
          <Body primitive="p" size={showMobileFontSize ? 'small' : 'large'}>
            {planName}
          </Body>
        </Spacing>
        <div className="width40 displayInlineFlex">
          <div className="textAlignRight width75">
            <Body primitive="p" size={showMobileFontSize ? 'small' : 'large'}>
              {charges}
            </Body>
          </div>
        </div>
      </Row>
    </div>
  );
};

export default CommonDiscount;

CommonDiscount.propTypes = {
  title: PropTypes.any,
  planName: PropTypes.any,
  charges: PropTypes.any,
};
